// auto initialization
$9e26441ab3e7893a$var$init();
function $9e26441ab3e7893a$var$init() {
    const toggles = document.getElementsByClassName("drawer-toggle");
    const numToggles = toggles.length;
    for(let i = 0; i < numToggles; i++){
        const t = toggles[i];
        t.addEventListener("click", $9e26441ab3e7893a$var$onToggleClicked);
    }
}
function $9e26441ab3e7893a$var$onToggleClicked(event) {
    const toggle = event.target;
    // update drawer props
    const drawer = toggle.closest(".link-in-drawer");
    const isExpanded = drawer.dataset.expanded === true || drawer.dataset.expanded === "true";
    const newState = !isExpanded;
    drawer.dataset.expanded = newState;
    // update toggle props
    toggle.setAttribute("aria-expanded", newState);
}


//# sourceMappingURL=writing.js.map
